import { withRouter } from "react-router-dom";
import React from 'react';
import { Alert } from 'antd';
import { withTranslation } from 'react-i18next';

class CardDescription extends React.Component {
    render() {
        let { cardDescription, service_detail } = this.props;
        const { t } = this.props;
        let message, type;
        switch (service_detail['status']) {
            case 'closed':
                message = t('clients.card_description.closed', "You do not have this service active.");
                type = 'info';
                break;
            case 'expired':
                message = t('clients.card_description.expired', "Your service has expired. If you wish to continue using it please contact us.");
                type = 'warning';
                break;
            case 'working':
                message = t('clients.card_description.working', { start_date: service_detail.start_date, end_date: service_detail.end_date });
                type = 'success';
                break;
            case 'requested':
                message = t('clients.card_description.requested', "You have requested this service activation. We will contact you shortly.");
                type = 'info';
                break;
            default:
                message = t('clients.card_description.no_info', "You do not have this service active.");
                type = 'info';
                break;
        }

        return (
            <div>
                <p>{cardDescription}</p>
                <Alert message={message} type={type} showIcon />
            </div>
        );
    }
}

export default withRouter(withTranslation()(CardDescription));


// WEBPACK FOOTER //
// ./src/containers/ClientZone/CardDescription.js